import { apiClient } from './client';

export interface ClaudeUsage {
  usedTokens: number;
  limitTokens: number;
  windowStart: string;
  resetAt: string;
}

export const getClaudeUsage = () =>
  apiClient.get<ClaudeUsage>('/api/admin/usage/claude').then((r) => r.data);
